import {origins, states} from '@/constants/query-constants';

export const getQueryOriginsOptions = () => {
    let array = [];
    Object.keys(origins).forEach((key) => {
        array.push({
            value: key,
            text: origins[key]
        });
    });
    return array;
};

export const getQueryStatesOptions = () => {
    let array = [];
    Object.keys(states).forEach((key) => {
        array.push({
            value: key,
            text: states[key]
        });
    });
    return array;
};

export const getQueryOriginByCode = (code) => origins[code];
export const getQueryStatusByCode = (code) => states[code];